<template>
  <section class="dp-layout">

    <section class="dp-left">
      <DepartmentPane
        :key="treeDirectoryScope"
        :directory-scope="treeDirectoryScope"
        :pane-title="treePaneTitle"
        @tree-node-click="treeNodeClick"
      ></DepartmentPane>
    </section>

    <section class="dp-right">

      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="学生" name="0">
          <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

          <!--列表-->
          <!-- 列表：tbl-scroll-host + height 保证操作列与表体同步滚动。最后更新：2026-08-31 -->
          <div class="tbl-scroll-host">
          <el-table height="100%" :data="users" v-loading="listLoading" @select="dialogCheck" @row-click="selectCurrentRow"
            ref="table" style="width: 100%" class="custom-tbl">
            <el-table-column type="selection" width="50"></el-table-column>
            <el-table-column prop="Id" label="订单号" min-width="110"></el-table-column>
            <el-table-column prop="CardNo" label="卡号" min-width="100"></el-table-column>
            <el-table-column prop="UserName" label="姓名" min-width="80"></el-table-column>
            <el-table-column prop="TotalMoney" label="总额" min-width="76" align="right"
              :formatter="(row) => formatCellMoney(row.TotalMoney)"></el-table-column>
            <el-table-column prop="DiscountMoney" label="优惠额" min-width="76" align="right"
              :formatter="(row) => formatCellMoney(row.DiscountMoney)"></el-table-column>
            <el-table-column prop="PayMoney" label="总支付额" min-width="88" align="right"
              :formatter="(row) => formatCellMoney(row.PayMoney)"></el-table-column>
            <el-table-column label="支付构成" min-width="100">
              <template slot-scope="scope">
                <template v-if="scope.row.HasSubsidyWalletPortion && scope.row.UserPayMoney != null && scope.row.SubsidyPayMoney != null">
                  <span>普通 {{ formatCellMoney(scope.row.UserPayMoney) }}</span>
                  <span> / </span>
                  <span class="pay-split-subsidy">专项 {{ formatCellMoney(scope.row.SubsidyPayMoney) }}</span>
                </template>
                <span v-else class="pay-split-plain">—</span>
              </template>
            </el-table-column>
            <el-table-column prop="PayType" label="支付类型" min-width="80" :formatter="formatPayType">
            </el-table-column>

            <el-table-column prop="Transactions" label="消费模式" min-width="92" :formatter="formatTransactions">
            </el-table-column>

            <el-table-column prop="PayTime" label="交易时间" min-width="100"></el-table-column>
            <el-table-column prop="AccountingDate" label="财务归属日" min-width="100"></el-table-column>

            <el-table-column prop="Status" label="状态" min-width="88" align="center">
              <template slot-scope="scope">
                <el-tag :type="scope.row.Status == '1' ? 'success' : 'danger'" disable-transitions>{{ scope.row.Status == '1' ? '已支付' : '已撤销' }}</el-tag>
              </template>
            </el-table-column>

            <el-table-column prop="DepartmentName" label="部门" min-width="96"></el-table-column>

            <el-table-column prop="DeviceSerialNo" label="序列号" min-width="120"></el-table-column>
            <el-table-column prop="InstallAddress" label="安装位置" min-width="100"></el-table-column>

            <el-table-column fixed="right" label="操作" width="80">
              <template slot-scope="scope">
                <el-button v-if="scope.row.Status == '1' && scope.row.SourceType != '水电控'"
                  class="consumption-refund-btn" @click="handleRevocation(scope.row)" type="text">退还</el-button>
              </template>
            </el-table-column>

          </el-table>
          </div>
        </el-tab-pane>
        <el-tab-pane label="教师" name="1">
          <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>
          <!--列表-->
          <!-- 列表：tbl-scroll-host + height 保证操作列与表体同步滚动。最后更新：2026-08-31 -->
          <div class="tbl-scroll-host">
          <el-table height="100%" :data="users" v-loading="listLoading" @select="dialogCheck" @row-click="selectCurrentRow"
            ref="table" style="width: 100%" class="custom-tbl">
            <el-table-column type="selection" width="50"></el-table-column>
            <el-table-column prop="Id" label="订单号" min-width="110"></el-table-column>
            <el-table-column prop="CardNo" label="卡号" min-width="100"></el-table-column>
            <el-table-column prop="UserName" label="姓名" min-width="80"></el-table-column>
            <el-table-column prop="TotalMoney" label="总额" min-width="76" align="right"
              :formatter="(row) => formatCellMoney(row.TotalMoney)"></el-table-column>
            <el-table-column prop="DiscountMoney" label="优惠额" min-width="76" align="right"
              :formatter="(row) => formatCellMoney(row.DiscountMoney)"></el-table-column>
            <el-table-column prop="PayMoney" label="总支付额" min-width="88" align="right"
              :formatter="(row) => formatCellMoney(row.PayMoney)"></el-table-column>
            <el-table-column label="支付构成" min-width="100">
              <template slot-scope="scope">
                <template v-if="scope.row.HasSubsidyWalletPortion && scope.row.UserPayMoney != null && scope.row.SubsidyPayMoney != null">
                  <span>普通 {{ formatCellMoney(scope.row.UserPayMoney) }}</span>
                  <span> / </span>
                  <span class="pay-split-subsidy">专项 {{ formatCellMoney(scope.row.SubsidyPayMoney) }}</span>
                </template>
                <span v-else class="pay-split-plain">—</span>
              </template>
            </el-table-column>
            <el-table-column prop="PayType" label="支付类型" min-width="80" :formatter="formatPayType">
            </el-table-column>

            <el-table-column prop="Transactions" label="消费模式" min-width="92" :formatter="formatTransactions">
            </el-table-column>

            <el-table-column prop="PayTime" label="交易时间" min-width="100"></el-table-column>
            <el-table-column prop="AccountingDate" label="财务归属日" min-width="100"></el-table-column>

            <el-table-column prop="Status" label="状态" min-width="88" align="center">
              <template slot-scope="scope">
                <el-tag :type="scope.row.Status == '1' ? 'success' : 'danger'" disable-transitions>{{ scope.row.Status == '1' ? '已支付' : '已撤销' }}</el-tag>
              </template>
            </el-table-column>

            <el-table-column prop="DepartmentName" label="部门" min-width="96"></el-table-column>

            <el-table-column prop="DeviceSerialNo" label="序列号" min-width="120"></el-table-column>
            <el-table-column prop="InstallAddress" label="安装位置" min-width="100"></el-table-column>

            <!-- <el-table-column prop="SourceType" label="来源类型">
              <template slot-scope="scope">
                <span v-if="scope.row.SourceType === '水电控'" style="color: var(--btn-primary, #2563eb); cursor: pointer;"
                  @click="showWaterElectricDetail(scope.row)">
                  {{ scope.row.SourceType }}
                </span>
                <span v-else>
                  {{ scope.row.SourceType }}
                </span>
              </template>
            </el-table-column> -->

            <el-table-column fixed="right" label="操作" width="80">
              <template slot-scope="scope">
                <el-button v-if="scope.row.Status == '1' && scope.row.Transactions != '4'"
                  class="consumption-refund-btn" @click="handleRevocation(scope.row)" type="text">退还</el-button>
              </template>
            </el-table-column>

          </el-table>
          </div>

        </el-tab-pane>
      </el-tabs>

      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="10" :total="total"
          style="float: right"></el-pagination>
      </el-col>
    </section>

    <el-dialog title="水电控详情" :visible.sync="waterElectricDialogVisible" width="400px">
      <div v-if="currentWaterElectric" style="padding: 10px 0;">
        <el-descriptions column="1" border>
          <el-descriptions-item label="设备描述">{{ currentWaterElectric.DeviceDesc || '-' }}</el-descriptions-item>
          <el-descriptions-item label="工作模式">
            {{ currentWaterElectric.WorkingMode === 1 ? '计时' : (currentWaterElectric.WorkingMode === 2 ? '计量' : '-') }}
          </el-descriptions-item>
          <el-descriptions-item label="用量">{{ currentWaterElectric.Usage != null ? currentWaterElectric.Usage : '-'
            }}</el-descriptions-item>
          <el-descriptions-item label="时长">{{ currentWaterElectric.Duration != null ? currentWaterElectric.Duration :
            '-'
            }}</el-descriptions-item>
        </el-descriptions>
      </div>
    </el-dialog>

  </section>
</template>

<script>
import util from "../../../util/date";
import { getUserConsumerListPage, revocation, exportConsumptionRecords } from '../../api/modules/consumption';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'

export default {
  components: { Toolbar, DepartmentPane },
  data() {
    return {
      waterElectricDialogVisible: false,
      currentWaterElectric: null,
      activeName: "0",
      filters: {
      },
      searchList: [
        {
          label: '卡号',
          key: 'cardId',
          width: '120px',
        },
        {
          label: '姓名',
          key: 'name',
          width: '110px',
        },
        {
          label: '开始日期',
          key: 'date',
          type: 'date',
          width: '160px',
        },
        {
          label: '结束日期',
          key: 'endDate',
          type: 'date',
          width: '160px',
        },
      ],
      buttonList: [],
      options: [],
      users: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      statusList: [
        { name: "激活", value: true },
        { name: "禁用", value: false },
      ],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
      currentRow: null,
      isResouceShow: 0,
      DepartmentId: ""
    };
  },
  computed: {
    /** 学生=家校，教师=内部通讯录。最后更新：2026-09-04 */
    treeDirectoryScope() {
      return String(this.activeName) === "1" ? "internal" : "teaching";
    },
    treePaneTitle() {
      return this.treeDirectoryScope === "internal" ? "内部通讯录" : "家校通讯录";
    },
  },
  methods: {
    showWaterElectricDetail(row) {
      this.currentWaterElectric = row;
      this.waterElectricDialogVisible = true;
    },
    handleClick(tab, event) {
      this.page = 1;
      this.DepartmentId = "";
      this.users = [];
      this.total = 0;
      // 切 Tab 后由部门树 :key 重载并自动选中节点触发查询
    },

    formatTransactions: function (row, column) {
      var str = "";
      if (row.Transactions == '1') {
        str = "普通消费";
      } else if (row.Transactions == '2') {
        str = "时段消费"
      } else if (row.Transactions == '3') {
        str = "离线消费"
      } else if (row.Transactions == '4') {
        str = "限次消费"
      } else if (row.Transactions == '5') {
        str = "固定金额消费"
      } else if (row.Transactions == '6') {
        str = "手持机消费"
      } else if (row.Transactions == '7') {
        str = "订餐消费"
      }

      return str;
    },

    formatPayType: function (row, column) {
      if (row.Transactions == '6') {
        var str = "";
        if (row.PayType == '0') {
          str = "自由";
        } else if (row.PayType == '1') {
          str = "定额"
        } else if (row.PayType == '2') {
          str = "时段"
        } else if (row.PayType == '3') {
          str = "洗衣机"
        }
        return str;
      } else {
        var str = "";
        if (row.PayType == '1') {
          str = "刷卡";
        } else if (row.PayType == '2') {
          str = "人脸"
        }

        return str;
      }

    },

    /** 表格内金额展示（兼容接口返回 number / string） */
    formatCellMoney(val) {
      if (val === null || val === undefined || val === '') return '0.00';
      const n = Number(val);
      return Number.isFinite(n) ? n.toFixed(2) : String(val);
    },

    treeNodeClick(data, node, component) {
      this.DepartmentId = data.value
      this.page = 1;
      this.handleQuery();
    },

    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.selectCurrentRow(row);
      }
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(val, true);
      }
    },
    callFunction(item) {
      if (typeof item.search == 'object') {
        this.filters = item.search
      } else {
        this.filters = {
          key: item.search,
        }
      }
      this[item.Func].apply(this, item)
    },
    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },
    /**
     * 从 Blob 响应体解析错误信息：优先 JSON 的 msg；否则在排除 xlsx(zip) 魔数后回退为纯文本。最后更新：2026-04-05
     */
    async parseBlobJsonMsg(blob) {
      if (!(blob instanceof Blob)) return null;
      try {
        const head = await blob.slice(0, 4).arrayBuffer();
        const u8 = new Uint8Array(head);
        if (u8.length >= 2 && u8[0] === 0x50 && u8[1] === 0x4b) return null;
        const text = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsText(blob);
        });
        const trimmed = (text || '').trim();
        if (!trimmed) return null;
        try {
          const j = JSON.parse(trimmed);
          return j.msg || j.message || null;
        } catch (e) {
          if (trimmed.length <= 2000) return trimmed;
          return null;
        }
      } catch (e) {
        return null;
      }
    },

    //获取用户列表
    handleQuery() {
      const para = {
        page: this.page,
        departmentId: this.DepartmentId,
        ...this.filters,
        type: this.activeName
      };
      this.listLoading = true;
      getUserConsumerListPage(para)
        .then((res) => {
          const body = res && res.data;
          if (!body || body.success === false) {
            this.users = [];
            this.total = 0;
            this.$message.error((body && body.msg) || '查询失败');
            return;
          }
          const pg = body.response;
          if (pg && Array.isArray(pg.data)) {
            // dataCount=-1 表示翻页未重算总数，保留首页 total
            if (pg.dataCount != null && pg.dataCount >= 0) {
              this.total = pg.dataCount;
            }
            this.users = pg.data;
          } else {
            this.users = [];
            this.total = 0;
          }
        })
        .catch((err) => {
          this.users = [];
          this.total = 0;
          let msg = '网络错误';
          const d = err.response && err.response.data;
          if (d && typeof d === 'object' && !(d instanceof Blob) && d.msg) {
            msg = d.msg;
          } else if (d instanceof Blob) {
            this.parseBlobJsonMsg(d).then((m) => {
              if (m) this.$message.error(m);
              else this.$message.error(msg);
            });
            return;
          } else if (typeof d === 'string') {
            try {
              const j = JSON.parse(d);
              if (j.msg) msg = j.msg;
            } catch (e) {
              /* ignore */
            }
          }
          this.$message.error(msg);
        })
        .finally(() => {
          this.listLoading = false;
        });
    },

    handleRevocation(row) {
      this.$confirm("确认退还该消费记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          const para = { OrderNo: row.Id };
          revocation(para)
            .then((res) => {
              if (util.isEmt.format(res)) {
                return;
              }
              if (res.data.success) {
                this.$message.success('退还成功');
              } else {
                this.$message.error(res.data.msg || '退还失败');
              }
              this.handleQuery();
            })
            .catch(() => {
              this.$message.error('网络错误');
            });
        })
        .catch(() => {});
    },
    async exportExcel() {
      const para = {
        page: this.page,
        departmentId: this.DepartmentId,
        ...this.filters,
        type: this.activeName
      };
      const fileName = this.activeName == 0 ? '学生用户消费记录' : '教师用户消费记录';
      try {
        const response = await exportConsumptionRecords(para);
        // 兼容旧版拦截器把错误 resolve 成 { success:false, message } 的情况
        if (!response || typeof response.status !== 'number' || !response.config) {
          const msg =
            (response && (response.msg || response.message)) || '导出失败';
          this.$message.error(msg);
          return;
        }
        const ct =
          (response.headers &&
            (response.headers['content-type'] || response.headers['Content-Type'])) ||
          '';
        if (ct.includes('application/json')) {
          const msg = await this.parseBlobJsonMsg(response.data);
          this.$message.error(msg || '导出失败');
          return;
        }
        if (!response.data || (response.data.size != null && response.data.size === 0)) {
          this.$message.warning('导出数据为空');
          return;
        }
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName + '.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } catch (error) {
        const blob = error.response && error.response.data;
        if (blob instanceof Blob) {
          const msg = await this.parseBlobJsonMsg(blob);
          this.$message.error(msg || '导出失败');
          return;
        }
        const d = error.response && error.response.data;
        if (d && typeof d === 'string' && d.trim()) {
          try {
            const j = JSON.parse(d);
            this.$message.error(j.msg || j.message || d);
          } catch (e) {
            this.$message.error(d.trim());
          }
          return;
        }
        if (d && typeof d === 'object' && d.msg) {
          this.$message.error(d.msg);
          return;
        }
        console.error('下载失败:', error);
        this.$message.error('导出失败，请稍后重试');
      }
    },
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];

    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}

/* 与旧版一致：长文案自然换行；关闭单元格默认 ellipsis，避免状态等列在标签后出现「..」 */
.custom-tbl /deep/ .el-table .cell {
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  line-height: 1.4;
  overflow: visible;
  text-overflow: clip;
}

.pay-split-subsidy {
  color: var(--btn-primary, #2563eb);
}

.pay-split-plain {
  color: #909399;
}

/* 退还：危险操作，与 Element danger 色一致 */
.custom-tbl /deep/ .consumption-refund-btn {
  color: #f56c6c;
}
.custom-tbl /deep/ .consumption-refund-btn:hover {
  color: #f78989;
}

</style>
